"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabelStyle = getLabelStyle;
exports.getRadioMarkInnerStyle = getRadioMarkInnerStyle;
exports.getRadioMarkOuterStyle = getRadioMarkOuterStyle;
exports.getRootStyle = getRootStyle;

function getInnerBackgroundColor({
  $checked: checked,
  $disabled: disabled,
  $isError: errored,
  $isHovered: hovered,
  $theme: theme
}) {
  if (errored) {
    return theme.colors.negative400;
  }

  if (disabled) {
    return checked ? theme.colors.mono500 : theme.colors.mono200;
  }

  if (checked) {
    return hovered ? theme.colors.primary300 : theme.colors.primary400;
  }

  return theme.colors.mono200;
}

function getOuterBackgroundColor({
  $checked: checked,
  $disabled: disabled,
  $theme: theme
}) {
  if (disabled) {
    return theme.colors.mono200;
  }

  if (checked) {
    return theme.colors.mono100;
  }

  return theme.colors.mono200;
}

function getOuterBorderColor({
  $checked: checked,
  $disabled: disabled,
  $isError: errored,
  $isHovered: hovered,
  $theme: theme
}) {
  if (errored) {
    return theme.colors.negative400;
  }

  if (disabled) {
    return theme.colors.mono200;
  }

  if (checked) {
    return hovered ? theme.colors.primary300 : theme.colors.primary400;
  }

  return hovered ? theme.colors.mono900 : theme.colors.mono600;
}

function getRadioMarkInnerStyle(styleArgs) {
  const {
    $checked: checked
  } = styleArgs;
  const uncheckedDimensions = {
    height: '0px',
    width: '0px'
  };
  const checkedDimensions = {
    height: '8px',
    width: '8px'
  };
  return {
    backgroundColor: getInnerBackgroundColor(styleArgs),
    ...(checked ? checkedDimensions : uncheckedDimensions)
  };
}

function getRadioMarkOuterStyle(styleArgs) {
  return {
    height: '18px',
    width: '18px',
    backgroundColor: getOuterBackgroundColor(styleArgs),
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: getOuterBorderColor(styleArgs)
  };
}

function getLabelStyle({
  $disabled: disabled,
  $theme: theme
}) {
  return {
    color: disabled ? theme.colors.mono500 : theme.colors.mono800
  };
}

function getRootStyle({
  $isFocused: isFocused
}) {
  return {
    outline: isFocused ? '5px auto #276ddd' : ''
  };
}